// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/tasks.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "api.devplan.types.tasks";

export enum ScopeStatus {
  IN_SCOPE = 0,
  OUT_OF_SCOPE = 1,
}

export function scopeStatusFromJSON(object: any): ScopeStatus {
  switch (object) {
    case 0:
    case "IN_SCOPE":
      return ScopeStatus.IN_SCOPE;
    case 1:
    case "OUT_OF_SCOPE":
      return ScopeStatus.OUT_OF_SCOPE;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ScopeStatus");
  }
}

export function scopeStatusToJSON(object: ScopeStatus): string {
  switch (object) {
    case ScopeStatus.IN_SCOPE:
      return "IN_SCOPE";
    case ScopeStatus.OUT_OF_SCOPE:
      return "OUT_OF_SCOPE";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ScopeStatus");
  }
}

export enum ProgressStatus {
  NOT_STARTED = 0,
  IN_PROGRESS = 1,
  DONE = 2,
  WONT_DO = 3,
}

export function progressStatusFromJSON(object: any): ProgressStatus {
  switch (object) {
    case 0:
    case "NOT_STARTED":
      return ProgressStatus.NOT_STARTED;
    case 1:
    case "IN_PROGRESS":
      return ProgressStatus.IN_PROGRESS;
    case 2:
    case "DONE":
      return ProgressStatus.DONE;
    case 3:
    case "WONT_DO":
      return ProgressStatus.WONT_DO;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ProgressStatus");
  }
}

export function progressStatusToJSON(object: ProgressStatus): string {
  switch (object) {
    case ProgressStatus.NOT_STARTED:
      return "NOT_STARTED";
    case ProgressStatus.IN_PROGRESS:
      return "IN_PROGRESS";
    case ProgressStatus.DONE:
      return "DONE";
    case ProgressStatus.WONT_DO:
      return "WONT_DO";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ProgressStatus");
  }
}

export enum ApprovalStatus {
  APPROVAL_UNDEFINED = 0,
  APPROVED = 1,
  NOT_APPROVED = 2,
}

export function approvalStatusFromJSON(object: any): ApprovalStatus {
  switch (object) {
    case 0:
    case "APPROVAL_UNDEFINED":
      return ApprovalStatus.APPROVAL_UNDEFINED;
    case 1:
    case "APPROVED":
      return ApprovalStatus.APPROVED;
    case 2:
    case "NOT_APPROVED":
      return ApprovalStatus.NOT_APPROVED;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ApprovalStatus");
  }
}

export function approvalStatusToJSON(object: ApprovalStatus): string {
  switch (object) {
    case ApprovalStatus.APPROVAL_UNDEFINED:
      return "APPROVAL_UNDEFINED";
    case ApprovalStatus.APPROVED:
      return "APPROVED";
    case ApprovalStatus.NOT_APPROVED:
      return "NOT_APPROVED";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ApprovalStatus");
  }
}

export enum LockStatus {
  LOCK_UNDEFINED = 0,
  LOCKED = 1,
  NOT_LOCKED = 2,
}

export function lockStatusFromJSON(object: any): LockStatus {
  switch (object) {
    case 0:
    case "LOCK_UNDEFINED":
      return LockStatus.LOCK_UNDEFINED;
    case 1:
    case "LOCKED":
      return LockStatus.LOCKED;
    case 2:
    case "NOT_LOCKED":
      return LockStatus.NOT_LOCKED;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum LockStatus");
  }
}

export function lockStatusToJSON(object: LockStatus): string {
  switch (object) {
    case LockStatus.LOCK_UNDEFINED:
      return "LOCK_UNDEFINED";
    case LockStatus.LOCKED:
      return "LOCKED";
    case LockStatus.NOT_LOCKED:
      return "NOT_LOCKED";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum LockStatus");
  }
}

export enum AmbiguityLevel {
  UNKNOWN = 0,
  LOW_AMBIGUITY = 1,
  MEDIUM_AMBIGUITY = 2,
  HIGH_AMBIGUITY = 3,
}

export function ambiguityLevelFromJSON(object: any): AmbiguityLevel {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return AmbiguityLevel.UNKNOWN;
    case 1:
    case "LOW_AMBIGUITY":
      return AmbiguityLevel.LOW_AMBIGUITY;
    case 2:
    case "MEDIUM_AMBIGUITY":
      return AmbiguityLevel.MEDIUM_AMBIGUITY;
    case 3:
    case "HIGH_AMBIGUITY":
      return AmbiguityLevel.HIGH_AMBIGUITY;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum AmbiguityLevel");
  }
}

export function ambiguityLevelToJSON(object: AmbiguityLevel): string {
  switch (object) {
    case AmbiguityLevel.UNKNOWN:
      return "UNKNOWN";
    case AmbiguityLevel.LOW_AMBIGUITY:
      return "LOW_AMBIGUITY";
    case AmbiguityLevel.MEDIUM_AMBIGUITY:
      return "MEDIUM_AMBIGUITY";
    case AmbiguityLevel.HIGH_AMBIGUITY:
      return "HIGH_AMBIGUITY";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum AmbiguityLevel");
  }
}

export interface ProjectPlan {
  id: string;
  companyId: number;
  title: string;
  description: string;
  projectId: string;
  parentId?: string | undefined;
  details?: ProjectPlanDetails | undefined;
}

export interface ProjectPlanDetails {
  /** Ordered ids of the features */
  orderedFeatures: string[];
  /** Map from group name ("WIP", "Approved") to ordered list of feature IDs */
  groupedFeaturesOrder: { [key: string]: FeatureOrder };
}

export interface ProjectPlanDetails_GroupedFeaturesOrderEntry {
  key: string;
  value: FeatureOrder | undefined;
}

export interface FeatureOrder {
  featureIds: string[];
}

export interface Feature {
  id: string;
  companyId: number;
  title: string;
  description: string;
  projectId: string;
  parentId?: string | undefined;
  details?: FeatureDetails | undefined;
  createdAt: Date | undefined;
  numericId?: number | undefined;
}

export interface FeatureDetails {
  /** Ordered ids of the tasks. */
  orderedTasks: string[];
  /** Id of the user who this feature is assigned to. */
  assignee?: string | undefined;
  scopeStatus: ScopeStatus;
  progressStatus: ProgressStatus;
  ambiguity?: AmbiguityEstimate | undefined;
  timeEstimate?: TimeBucketEstimate | undefined;
  approvalStatus: ApprovalStatus;
  repoNames: string[];
}

export interface Task {
  id: string;
  companyId: number;
  title: string;
  description: string;
  projectId: string;
  parentId?: string | undefined;
  details?: TaskDetails | undefined;
  numericId?: number | undefined;
}

export interface TaskDependency {
  taskId: string;
}

export interface TaskDetails {
  ambiguityEstimate?:
    | AmbiguityEstimate
    | undefined;
  /** Id of the user who this task is assigned to. */
  assignee?: string | undefined;
  timeEstimate?: TimeBucketEstimate | undefined;
  repoName?: string | undefined;
  progressStatus: ProgressStatus;
  lockStatus: LockStatus;
  /** Tasks this one depends on. */
  dependencies: TaskDependency[];
}

export interface TimeBucketEstimate {
  bucket: string;
  justification: string;
  minHours: number;
  maxHours: number;
}

export interface TimeEstimate {
  minHours: number;
  maxHours: number;
  /** string size_label = 4; */
  justification: string;
}

export interface AmbiguityEstimate {
  level: AmbiguityLevel;
  justification: string;
}

export interface Roadmap {
  id: string;
  title: string;
  description: string;
  /** Ids of the documents in the backlog. If empty, all available features should be in the backlog. */
  backlogDocumentIds: string[];
  cycles: RoadmapCycle[];
}

export interface RoadmapCycle {
  id: string;
  title: string;
  description: string;
  documentIds: string[];
}

export interface PlanSimulation {
  companyId: number;
  target: PlanSimulation_Target | undefined;
  data: PlanSimulationData | undefined;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
}

export enum PlanSimulation_TargetType {
  UNKNOWN = 0,
  PROJECT = 1,
  PROJECT_GROUP_ITEM = 2,
}

export function planSimulation_TargetTypeFromJSON(object: any): PlanSimulation_TargetType {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return PlanSimulation_TargetType.UNKNOWN;
    case 1:
    case "PROJECT":
      return PlanSimulation_TargetType.PROJECT;
    case 2:
    case "PROJECT_GROUP_ITEM":
      return PlanSimulation_TargetType.PROJECT_GROUP_ITEM;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum PlanSimulation_TargetType");
  }
}

export function planSimulation_TargetTypeToJSON(object: PlanSimulation_TargetType): string {
  switch (object) {
    case PlanSimulation_TargetType.UNKNOWN:
      return "UNKNOWN";
    case PlanSimulation_TargetType.PROJECT:
      return "PROJECT";
    case PlanSimulation_TargetType.PROJECT_GROUP_ITEM:
      return "PROJECT_GROUP_ITEM";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum PlanSimulation_TargetType");
  }
}

export interface PlanSimulation_Target {
  /** ID of the target for this simulation */
  id: string;
  /** Type of the target for the simulation */
  type: PlanSimulation_TargetType;
}

export interface PlanSimulationData {
  items: PlanSimulationData_Item[];
}

export interface PlanSimulationData_Item {
  percentile: number;
  estimateHours: number;
}

function createBaseProjectPlan(): ProjectPlan {
  return { id: "", companyId: 0, title: "", description: "", projectId: "", parentId: undefined, details: undefined };
}

export const ProjectPlan: MessageFns<ProjectPlan> = {
  encode(message: ProjectPlan, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    if (message.title !== "") {
      writer.uint32(26).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.projectId !== "") {
      writer.uint32(42).string(message.projectId);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    if (message.details !== undefined) {
      ProjectPlanDetails.encode(message.details, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectPlan {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectPlan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.details = ProjectPlanDetails.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectPlan {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : "",
      parentId: isSet(object.parentId)
        ? globalThis.String(object.parentId)
        : isSet(object.parent_id)
        ? globalThis.String(object.parent_id)
        : undefined,
      details: isSet(object.details) ? ProjectPlanDetails.fromJSON(object.details) : undefined,
    };
  },

  toJSON(message: ProjectPlan): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.projectId !== "") {
      obj.projectId = message.projectId;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.details !== undefined) {
      obj.details = ProjectPlanDetails.toJSON(message.details);
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectPlan>): ProjectPlan {
    return ProjectPlan.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectPlan>): ProjectPlan {
    const message = createBaseProjectPlan();
    message.id = object.id ?? "";
    message.companyId = object.companyId ?? 0;
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    message.projectId = object.projectId ?? "";
    message.parentId = object.parentId ?? undefined;
    message.details = (object.details !== undefined && object.details !== null)
      ? ProjectPlanDetails.fromPartial(object.details)
      : undefined;
    return message;
  },
};

function createBaseProjectPlanDetails(): ProjectPlanDetails {
  return { orderedFeatures: [], groupedFeaturesOrder: {} };
}

export const ProjectPlanDetails: MessageFns<ProjectPlanDetails> = {
  encode(message: ProjectPlanDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.orderedFeatures) {
      writer.uint32(10).string(v!);
    }
    globalThis.Object.entries(message.groupedFeaturesOrder).forEach(([key, value]: [string, FeatureOrder]) => {
      ProjectPlanDetails_GroupedFeaturesOrderEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectPlanDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectPlanDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orderedFeatures.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = ProjectPlanDetails_GroupedFeaturesOrderEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.groupedFeaturesOrder[entry2.key] = entry2.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectPlanDetails {
    return {
      orderedFeatures: globalThis.Array.isArray(object?.orderedFeatures)
        ? object.orderedFeatures.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ordered_features)
        ? object.ordered_features.map((e: any) => globalThis.String(e))
        : [],
      groupedFeaturesOrder: isObject(object.groupedFeaturesOrder)
        ? (globalThis.Object.entries(object.groupedFeaturesOrder) as [string, any][]).reduce(
          (acc: { [key: string]: FeatureOrder }, [key, value]: [string, any]) => {
            acc[key] = FeatureOrder.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.grouped_features_order)
        ? (globalThis.Object.entries(object.grouped_features_order) as [string, any][]).reduce(
          (acc: { [key: string]: FeatureOrder }, [key, value]: [string, any]) => {
            acc[key] = FeatureOrder.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: ProjectPlanDetails): unknown {
    const obj: any = {};
    if (message.orderedFeatures?.length) {
      obj.orderedFeatures = message.orderedFeatures;
    }
    if (message.groupedFeaturesOrder) {
      const entries = globalThis.Object.entries(message.groupedFeaturesOrder) as [string, FeatureOrder][];
      if (entries.length > 0) {
        obj.groupedFeaturesOrder = {};
        entries.forEach(([k, v]) => {
          obj.groupedFeaturesOrder[k] = FeatureOrder.toJSON(v);
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectPlanDetails>): ProjectPlanDetails {
    return ProjectPlanDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectPlanDetails>): ProjectPlanDetails {
    const message = createBaseProjectPlanDetails();
    message.orderedFeatures = object.orderedFeatures?.map((e) => e) || [];
    message.groupedFeaturesOrder =
      (globalThis.Object.entries(object.groupedFeaturesOrder ?? {}) as [string, FeatureOrder][]).reduce(
        (acc: { [key: string]: FeatureOrder }, [key, value]: [string, FeatureOrder]) => {
          if (value !== undefined) {
            acc[key] = FeatureOrder.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    return message;
  },
};

function createBaseProjectPlanDetails_GroupedFeaturesOrderEntry(): ProjectPlanDetails_GroupedFeaturesOrderEntry {
  return { key: "", value: undefined };
}

export const ProjectPlanDetails_GroupedFeaturesOrderEntry: MessageFns<ProjectPlanDetails_GroupedFeaturesOrderEntry> = {
  encode(
    message: ProjectPlanDetails_GroupedFeaturesOrderEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      FeatureOrder.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectPlanDetails_GroupedFeaturesOrderEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectPlanDetails_GroupedFeaturesOrderEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = FeatureOrder.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectPlanDetails_GroupedFeaturesOrderEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? FeatureOrder.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: ProjectPlanDetails_GroupedFeaturesOrderEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = FeatureOrder.toJSON(message.value);
    }
    return obj;
  },

  create(
    base?: DeepPartial<ProjectPlanDetails_GroupedFeaturesOrderEntry>,
  ): ProjectPlanDetails_GroupedFeaturesOrderEntry {
    return ProjectPlanDetails_GroupedFeaturesOrderEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<ProjectPlanDetails_GroupedFeaturesOrderEntry>,
  ): ProjectPlanDetails_GroupedFeaturesOrderEntry {
    const message = createBaseProjectPlanDetails_GroupedFeaturesOrderEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? FeatureOrder.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseFeatureOrder(): FeatureOrder {
  return { featureIds: [] };
}

export const FeatureOrder: MessageFns<FeatureOrder> = {
  encode(message: FeatureOrder, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.featureIds) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FeatureOrder {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFeatureOrder();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.featureIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FeatureOrder {
    return {
      featureIds: globalThis.Array.isArray(object?.featureIds)
        ? object.featureIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.feature_ids)
        ? object.feature_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: FeatureOrder): unknown {
    const obj: any = {};
    if (message.featureIds?.length) {
      obj.featureIds = message.featureIds;
    }
    return obj;
  },

  create(base?: DeepPartial<FeatureOrder>): FeatureOrder {
    return FeatureOrder.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FeatureOrder>): FeatureOrder {
    const message = createBaseFeatureOrder();
    message.featureIds = object.featureIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseFeature(): Feature {
  return {
    id: "",
    companyId: 0,
    title: "",
    description: "",
    projectId: "",
    parentId: undefined,
    details: undefined,
    createdAt: undefined,
    numericId: undefined,
  };
}

export const Feature: MessageFns<Feature> = {
  encode(message: Feature, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    if (message.title !== "") {
      writer.uint32(26).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.projectId !== "") {
      writer.uint32(42).string(message.projectId);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    if (message.details !== undefined) {
      FeatureDetails.encode(message.details, writer.uint32(58).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(66).fork()).join();
    }
    if (message.numericId !== undefined) {
      writer.uint32(72).int32(message.numericId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Feature {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFeature();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.details = FeatureDetails.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.numericId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Feature {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : "",
      parentId: isSet(object.parentId)
        ? globalThis.String(object.parentId)
        : isSet(object.parent_id)
        ? globalThis.String(object.parent_id)
        : undefined,
      details: isSet(object.details) ? FeatureDetails.fromJSON(object.details) : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      numericId: isSet(object.numericId)
        ? globalThis.Number(object.numericId)
        : isSet(object.numeric_id)
        ? globalThis.Number(object.numeric_id)
        : undefined,
    };
  },

  toJSON(message: Feature): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.projectId !== "") {
      obj.projectId = message.projectId;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.details !== undefined) {
      obj.details = FeatureDetails.toJSON(message.details);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.numericId !== undefined) {
      obj.numericId = Math.round(message.numericId);
    }
    return obj;
  },

  create(base?: DeepPartial<Feature>): Feature {
    return Feature.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Feature>): Feature {
    const message = createBaseFeature();
    message.id = object.id ?? "";
    message.companyId = object.companyId ?? 0;
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    message.projectId = object.projectId ?? "";
    message.parentId = object.parentId ?? undefined;
    message.details = (object.details !== undefined && object.details !== null)
      ? FeatureDetails.fromPartial(object.details)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.numericId = object.numericId ?? undefined;
    return message;
  },
};

function createBaseFeatureDetails(): FeatureDetails {
  return {
    orderedTasks: [],
    assignee: undefined,
    scopeStatus: 0,
    progressStatus: 0,
    ambiguity: undefined,
    timeEstimate: undefined,
    approvalStatus: 0,
    repoNames: [],
  };
}

export const FeatureDetails: MessageFns<FeatureDetails> = {
  encode(message: FeatureDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.orderedTasks) {
      writer.uint32(18).string(v!);
    }
    if (message.assignee !== undefined) {
      writer.uint32(26).string(message.assignee);
    }
    if (message.scopeStatus !== 0) {
      writer.uint32(32).int32(message.scopeStatus);
    }
    if (message.progressStatus !== 0) {
      writer.uint32(40).int32(message.progressStatus);
    }
    if (message.ambiguity !== undefined) {
      AmbiguityEstimate.encode(message.ambiguity, writer.uint32(50).fork()).join();
    }
    if (message.timeEstimate !== undefined) {
      TimeBucketEstimate.encode(message.timeEstimate, writer.uint32(66).fork()).join();
    }
    if (message.approvalStatus !== 0) {
      writer.uint32(72).int32(message.approvalStatus);
    }
    for (const v of message.repoNames) {
      writer.uint32(82).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FeatureDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFeatureDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orderedTasks.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.assignee = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.scopeStatus = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.progressStatus = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ambiguity = AmbiguityEstimate.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.timeEstimate = TimeBucketEstimate.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.approvalStatus = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.repoNames.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FeatureDetails {
    return {
      orderedTasks: globalThis.Array.isArray(object?.orderedTasks)
        ? object.orderedTasks.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.ordered_tasks)
        ? object.ordered_tasks.map((e: any) => globalThis.String(e))
        : [],
      assignee: isSet(object.assignee) ? globalThis.String(object.assignee) : undefined,
      scopeStatus: isSet(object.scopeStatus)
        ? scopeStatusFromJSON(object.scopeStatus)
        : isSet(object.scope_status)
        ? scopeStatusFromJSON(object.scope_status)
        : 0,
      progressStatus: isSet(object.progressStatus)
        ? progressStatusFromJSON(object.progressStatus)
        : isSet(object.progress_status)
        ? progressStatusFromJSON(object.progress_status)
        : 0,
      ambiguity: isSet(object.ambiguity) ? AmbiguityEstimate.fromJSON(object.ambiguity) : undefined,
      timeEstimate: isSet(object.timeEstimate)
        ? TimeBucketEstimate.fromJSON(object.timeEstimate)
        : isSet(object.time_estimate)
        ? TimeBucketEstimate.fromJSON(object.time_estimate)
        : undefined,
      approvalStatus: isSet(object.approvalStatus)
        ? approvalStatusFromJSON(object.approvalStatus)
        : isSet(object.approval_status)
        ? approvalStatusFromJSON(object.approval_status)
        : 0,
      repoNames: globalThis.Array.isArray(object?.repoNames)
        ? object.repoNames.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.repo_names)
        ? object.repo_names.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: FeatureDetails): unknown {
    const obj: any = {};
    if (message.orderedTasks?.length) {
      obj.orderedTasks = message.orderedTasks;
    }
    if (message.assignee !== undefined) {
      obj.assignee = message.assignee;
    }
    if (message.scopeStatus !== 0) {
      obj.scopeStatus = scopeStatusToJSON(message.scopeStatus);
    }
    if (message.progressStatus !== 0) {
      obj.progressStatus = progressStatusToJSON(message.progressStatus);
    }
    if (message.ambiguity !== undefined) {
      obj.ambiguity = AmbiguityEstimate.toJSON(message.ambiguity);
    }
    if (message.timeEstimate !== undefined) {
      obj.timeEstimate = TimeBucketEstimate.toJSON(message.timeEstimate);
    }
    if (message.approvalStatus !== 0) {
      obj.approvalStatus = approvalStatusToJSON(message.approvalStatus);
    }
    if (message.repoNames?.length) {
      obj.repoNames = message.repoNames;
    }
    return obj;
  },

  create(base?: DeepPartial<FeatureDetails>): FeatureDetails {
    return FeatureDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FeatureDetails>): FeatureDetails {
    const message = createBaseFeatureDetails();
    message.orderedTasks = object.orderedTasks?.map((e) => e) || [];
    message.assignee = object.assignee ?? undefined;
    message.scopeStatus = object.scopeStatus ?? 0;
    message.progressStatus = object.progressStatus ?? 0;
    message.ambiguity = (object.ambiguity !== undefined && object.ambiguity !== null)
      ? AmbiguityEstimate.fromPartial(object.ambiguity)
      : undefined;
    message.timeEstimate = (object.timeEstimate !== undefined && object.timeEstimate !== null)
      ? TimeBucketEstimate.fromPartial(object.timeEstimate)
      : undefined;
    message.approvalStatus = object.approvalStatus ?? 0;
    message.repoNames = object.repoNames?.map((e) => e) || [];
    return message;
  },
};

function createBaseTask(): Task {
  return {
    id: "",
    companyId: 0,
    title: "",
    description: "",
    projectId: "",
    parentId: undefined,
    details: undefined,
    numericId: undefined,
  };
}

export const Task: MessageFns<Task> = {
  encode(message: Task, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    if (message.title !== "") {
      writer.uint32(26).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.projectId !== "") {
      writer.uint32(42).string(message.projectId);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    if (message.details !== undefined) {
      TaskDetails.encode(message.details, writer.uint32(58).fork()).join();
    }
    if (message.numericId !== undefined) {
      writer.uint32(64).int32(message.numericId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Task {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.details = TaskDetails.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.numericId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Task {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : "",
      parentId: isSet(object.parentId)
        ? globalThis.String(object.parentId)
        : isSet(object.parent_id)
        ? globalThis.String(object.parent_id)
        : undefined,
      details: isSet(object.details) ? TaskDetails.fromJSON(object.details) : undefined,
      numericId: isSet(object.numericId)
        ? globalThis.Number(object.numericId)
        : isSet(object.numeric_id)
        ? globalThis.Number(object.numeric_id)
        : undefined,
    };
  },

  toJSON(message: Task): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.projectId !== "") {
      obj.projectId = message.projectId;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.details !== undefined) {
      obj.details = TaskDetails.toJSON(message.details);
    }
    if (message.numericId !== undefined) {
      obj.numericId = Math.round(message.numericId);
    }
    return obj;
  },

  create(base?: DeepPartial<Task>): Task {
    return Task.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Task>): Task {
    const message = createBaseTask();
    message.id = object.id ?? "";
    message.companyId = object.companyId ?? 0;
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    message.projectId = object.projectId ?? "";
    message.parentId = object.parentId ?? undefined;
    message.details = (object.details !== undefined && object.details !== null)
      ? TaskDetails.fromPartial(object.details)
      : undefined;
    message.numericId = object.numericId ?? undefined;
    return message;
  },
};

function createBaseTaskDependency(): TaskDependency {
  return { taskId: "" };
}

export const TaskDependency: MessageFns<TaskDependency> = {
  encode(message: TaskDependency, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.taskId !== "") {
      writer.uint32(10).string(message.taskId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TaskDependency {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTaskDependency();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.taskId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TaskDependency {
    return {
      taskId: isSet(object.taskId)
        ? globalThis.String(object.taskId)
        : isSet(object.task_id)
        ? globalThis.String(object.task_id)
        : "",
    };
  },

  toJSON(message: TaskDependency): unknown {
    const obj: any = {};
    if (message.taskId !== "") {
      obj.taskId = message.taskId;
    }
    return obj;
  },

  create(base?: DeepPartial<TaskDependency>): TaskDependency {
    return TaskDependency.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TaskDependency>): TaskDependency {
    const message = createBaseTaskDependency();
    message.taskId = object.taskId ?? "";
    return message;
  },
};

function createBaseTaskDetails(): TaskDetails {
  return {
    ambiguityEstimate: undefined,
    assignee: undefined,
    timeEstimate: undefined,
    repoName: undefined,
    progressStatus: 0,
    lockStatus: 0,
    dependencies: [],
  };
}

export const TaskDetails: MessageFns<TaskDetails> = {
  encode(message: TaskDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ambiguityEstimate !== undefined) {
      AmbiguityEstimate.encode(message.ambiguityEstimate, writer.uint32(18).fork()).join();
    }
    if (message.assignee !== undefined) {
      writer.uint32(26).string(message.assignee);
    }
    if (message.timeEstimate !== undefined) {
      TimeBucketEstimate.encode(message.timeEstimate, writer.uint32(34).fork()).join();
    }
    if (message.repoName !== undefined) {
      writer.uint32(42).string(message.repoName);
    }
    if (message.progressStatus !== 0) {
      writer.uint32(48).int32(message.progressStatus);
    }
    if (message.lockStatus !== 0) {
      writer.uint32(56).int32(message.lockStatus);
    }
    for (const v of message.dependencies) {
      TaskDependency.encode(v!, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TaskDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTaskDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ambiguityEstimate = AmbiguityEstimate.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.assignee = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.timeEstimate = TimeBucketEstimate.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.repoName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.progressStatus = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.lockStatus = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.dependencies.push(TaskDependency.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TaskDetails {
    return {
      ambiguityEstimate: isSet(object.ambiguityEstimate)
        ? AmbiguityEstimate.fromJSON(object.ambiguityEstimate)
        : isSet(object.ambiguity_estimate)
        ? AmbiguityEstimate.fromJSON(object.ambiguity_estimate)
        : undefined,
      assignee: isSet(object.assignee) ? globalThis.String(object.assignee) : undefined,
      timeEstimate: isSet(object.timeEstimate)
        ? TimeBucketEstimate.fromJSON(object.timeEstimate)
        : isSet(object.time_estimate)
        ? TimeBucketEstimate.fromJSON(object.time_estimate)
        : undefined,
      repoName: isSet(object.repoName)
        ? globalThis.String(object.repoName)
        : isSet(object.repo_name)
        ? globalThis.String(object.repo_name)
        : undefined,
      progressStatus: isSet(object.progressStatus)
        ? progressStatusFromJSON(object.progressStatus)
        : isSet(object.progress_status)
        ? progressStatusFromJSON(object.progress_status)
        : 0,
      lockStatus: isSet(object.lockStatus)
        ? lockStatusFromJSON(object.lockStatus)
        : isSet(object.lock_status)
        ? lockStatusFromJSON(object.lock_status)
        : 0,
      dependencies: globalThis.Array.isArray(object?.dependencies)
        ? object.dependencies.map((e: any) => TaskDependency.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TaskDetails): unknown {
    const obj: any = {};
    if (message.ambiguityEstimate !== undefined) {
      obj.ambiguityEstimate = AmbiguityEstimate.toJSON(message.ambiguityEstimate);
    }
    if (message.assignee !== undefined) {
      obj.assignee = message.assignee;
    }
    if (message.timeEstimate !== undefined) {
      obj.timeEstimate = TimeBucketEstimate.toJSON(message.timeEstimate);
    }
    if (message.repoName !== undefined) {
      obj.repoName = message.repoName;
    }
    if (message.progressStatus !== 0) {
      obj.progressStatus = progressStatusToJSON(message.progressStatus);
    }
    if (message.lockStatus !== 0) {
      obj.lockStatus = lockStatusToJSON(message.lockStatus);
    }
    if (message.dependencies?.length) {
      obj.dependencies = message.dependencies.map((e) => TaskDependency.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<TaskDetails>): TaskDetails {
    return TaskDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TaskDetails>): TaskDetails {
    const message = createBaseTaskDetails();
    message.ambiguityEstimate = (object.ambiguityEstimate !== undefined && object.ambiguityEstimate !== null)
      ? AmbiguityEstimate.fromPartial(object.ambiguityEstimate)
      : undefined;
    message.assignee = object.assignee ?? undefined;
    message.timeEstimate = (object.timeEstimate !== undefined && object.timeEstimate !== null)
      ? TimeBucketEstimate.fromPartial(object.timeEstimate)
      : undefined;
    message.repoName = object.repoName ?? undefined;
    message.progressStatus = object.progressStatus ?? 0;
    message.lockStatus = object.lockStatus ?? 0;
    message.dependencies = object.dependencies?.map((e) => TaskDependency.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTimeBucketEstimate(): TimeBucketEstimate {
  return { bucket: "", justification: "", minHours: 0, maxHours: 0 };
}

export const TimeBucketEstimate: MessageFns<TimeBucketEstimate> = {
  encode(message: TimeBucketEstimate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.bucket !== "") {
      writer.uint32(10).string(message.bucket);
    }
    if (message.justification !== "") {
      writer.uint32(18).string(message.justification);
    }
    if (message.minHours !== 0) {
      writer.uint32(24).int32(message.minHours);
    }
    if (message.maxHours !== 0) {
      writer.uint32(32).int32(message.maxHours);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TimeBucketEstimate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimeBucketEstimate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.bucket = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.justification = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.minHours = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.maxHours = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TimeBucketEstimate {
    return {
      bucket: isSet(object.bucket) ? globalThis.String(object.bucket) : "",
      justification: isSet(object.justification) ? globalThis.String(object.justification) : "",
      minHours: isSet(object.minHours)
        ? globalThis.Number(object.minHours)
        : isSet(object.min_hours)
        ? globalThis.Number(object.min_hours)
        : 0,
      maxHours: isSet(object.maxHours)
        ? globalThis.Number(object.maxHours)
        : isSet(object.max_hours)
        ? globalThis.Number(object.max_hours)
        : 0,
    };
  },

  toJSON(message: TimeBucketEstimate): unknown {
    const obj: any = {};
    if (message.bucket !== "") {
      obj.bucket = message.bucket;
    }
    if (message.justification !== "") {
      obj.justification = message.justification;
    }
    if (message.minHours !== 0) {
      obj.minHours = Math.round(message.minHours);
    }
    if (message.maxHours !== 0) {
      obj.maxHours = Math.round(message.maxHours);
    }
    return obj;
  },

  create(base?: DeepPartial<TimeBucketEstimate>): TimeBucketEstimate {
    return TimeBucketEstimate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TimeBucketEstimate>): TimeBucketEstimate {
    const message = createBaseTimeBucketEstimate();
    message.bucket = object.bucket ?? "";
    message.justification = object.justification ?? "";
    message.minHours = object.minHours ?? 0;
    message.maxHours = object.maxHours ?? 0;
    return message;
  },
};

function createBaseTimeEstimate(): TimeEstimate {
  return { minHours: 0, maxHours: 0, justification: "" };
}

export const TimeEstimate: MessageFns<TimeEstimate> = {
  encode(message: TimeEstimate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.minHours !== 0) {
      writer.uint32(8).int32(message.minHours);
    }
    if (message.maxHours !== 0) {
      writer.uint32(16).int32(message.maxHours);
    }
    if (message.justification !== "") {
      writer.uint32(26).string(message.justification);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TimeEstimate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimeEstimate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.minHours = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.maxHours = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.justification = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TimeEstimate {
    return {
      minHours: isSet(object.minHours)
        ? globalThis.Number(object.minHours)
        : isSet(object.min_hours)
        ? globalThis.Number(object.min_hours)
        : 0,
      maxHours: isSet(object.maxHours)
        ? globalThis.Number(object.maxHours)
        : isSet(object.max_hours)
        ? globalThis.Number(object.max_hours)
        : 0,
      justification: isSet(object.justification) ? globalThis.String(object.justification) : "",
    };
  },

  toJSON(message: TimeEstimate): unknown {
    const obj: any = {};
    if (message.minHours !== 0) {
      obj.minHours = Math.round(message.minHours);
    }
    if (message.maxHours !== 0) {
      obj.maxHours = Math.round(message.maxHours);
    }
    if (message.justification !== "") {
      obj.justification = message.justification;
    }
    return obj;
  },

  create(base?: DeepPartial<TimeEstimate>): TimeEstimate {
    return TimeEstimate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TimeEstimate>): TimeEstimate {
    const message = createBaseTimeEstimate();
    message.minHours = object.minHours ?? 0;
    message.maxHours = object.maxHours ?? 0;
    message.justification = object.justification ?? "";
    return message;
  },
};

function createBaseAmbiguityEstimate(): AmbiguityEstimate {
  return { level: 0, justification: "" };
}

export const AmbiguityEstimate: MessageFns<AmbiguityEstimate> = {
  encode(message: AmbiguityEstimate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.level !== 0) {
      writer.uint32(8).int32(message.level);
    }
    if (message.justification !== "") {
      writer.uint32(18).string(message.justification);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AmbiguityEstimate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAmbiguityEstimate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.level = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.justification = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AmbiguityEstimate {
    return {
      level: isSet(object.level) ? ambiguityLevelFromJSON(object.level) : 0,
      justification: isSet(object.justification) ? globalThis.String(object.justification) : "",
    };
  },

  toJSON(message: AmbiguityEstimate): unknown {
    const obj: any = {};
    if (message.level !== 0) {
      obj.level = ambiguityLevelToJSON(message.level);
    }
    if (message.justification !== "") {
      obj.justification = message.justification;
    }
    return obj;
  },

  create(base?: DeepPartial<AmbiguityEstimate>): AmbiguityEstimate {
    return AmbiguityEstimate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AmbiguityEstimate>): AmbiguityEstimate {
    const message = createBaseAmbiguityEstimate();
    message.level = object.level ?? 0;
    message.justification = object.justification ?? "";
    return message;
  },
};

function createBaseRoadmap(): Roadmap {
  return { id: "", title: "", description: "", backlogDocumentIds: [], cycles: [] };
}

export const Roadmap: MessageFns<Roadmap> = {
  encode(message: Roadmap, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.backlogDocumentIds) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.cycles) {
      RoadmapCycle.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Roadmap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoadmap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.backlogDocumentIds.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.cycles.push(RoadmapCycle.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Roadmap {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      backlogDocumentIds: globalThis.Array.isArray(object?.backlogDocumentIds)
        ? object.backlogDocumentIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.backlog_document_ids)
        ? object.backlog_document_ids.map((e: any) => globalThis.String(e))
        : [],
      cycles: globalThis.Array.isArray(object?.cycles) ? object.cycles.map((e: any) => RoadmapCycle.fromJSON(e)) : [],
    };
  },

  toJSON(message: Roadmap): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.backlogDocumentIds?.length) {
      obj.backlogDocumentIds = message.backlogDocumentIds;
    }
    if (message.cycles?.length) {
      obj.cycles = message.cycles.map((e) => RoadmapCycle.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<Roadmap>): Roadmap {
    return Roadmap.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Roadmap>): Roadmap {
    const message = createBaseRoadmap();
    message.id = object.id ?? "";
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    message.backlogDocumentIds = object.backlogDocumentIds?.map((e) => e) || [];
    message.cycles = object.cycles?.map((e) => RoadmapCycle.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRoadmapCycle(): RoadmapCycle {
  return { id: "", title: "", description: "", documentIds: [] };
}

export const RoadmapCycle: MessageFns<RoadmapCycle> = {
  encode(message: RoadmapCycle, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.documentIds) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoadmapCycle {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoadmapCycle();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.documentIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoadmapCycle {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      documentIds: globalThis.Array.isArray(object?.documentIds)
        ? object.documentIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.document_ids)
        ? object.document_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: RoadmapCycle): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.documentIds?.length) {
      obj.documentIds = message.documentIds;
    }
    return obj;
  },

  create(base?: DeepPartial<RoadmapCycle>): RoadmapCycle {
    return RoadmapCycle.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RoadmapCycle>): RoadmapCycle {
    const message = createBaseRoadmapCycle();
    message.id = object.id ?? "";
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    message.documentIds = object.documentIds?.map((e) => e) || [];
    return message;
  },
};

function createBasePlanSimulation(): PlanSimulation {
  return { companyId: 0, target: undefined, data: undefined, createdAt: undefined, updatedAt: undefined };
}

export const PlanSimulation: MessageFns<PlanSimulation> = {
  encode(message: PlanSimulation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    if (message.target !== undefined) {
      PlanSimulation_Target.encode(message.target, writer.uint32(18).fork()).join();
    }
    if (message.data !== undefined) {
      PlanSimulationData.encode(message.data, writer.uint32(26).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanSimulation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanSimulation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.target = PlanSimulation_Target.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.data = PlanSimulationData.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanSimulation {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      target: isSet(object.target) ? PlanSimulation_Target.fromJSON(object.target) : undefined,
      data: isSet(object.data) ? PlanSimulationData.fromJSON(object.data) : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: PlanSimulation): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.target !== undefined) {
      obj.target = PlanSimulation_Target.toJSON(message.target);
    }
    if (message.data !== undefined) {
      obj.data = PlanSimulationData.toJSON(message.data);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<PlanSimulation>): PlanSimulation {
    return PlanSimulation.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PlanSimulation>): PlanSimulation {
    const message = createBasePlanSimulation();
    message.companyId = object.companyId ?? 0;
    message.target = (object.target !== undefined && object.target !== null)
      ? PlanSimulation_Target.fromPartial(object.target)
      : undefined;
    message.data = (object.data !== undefined && object.data !== null)
      ? PlanSimulationData.fromPartial(object.data)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBasePlanSimulation_Target(): PlanSimulation_Target {
  return { id: "", type: 0 };
}

export const PlanSimulation_Target: MessageFns<PlanSimulation_Target> = {
  encode(message: PlanSimulation_Target, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanSimulation_Target {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanSimulation_Target();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanSimulation_Target {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      type: isSet(object.type) ? planSimulation_TargetTypeFromJSON(object.type) : 0,
    };
  },

  toJSON(message: PlanSimulation_Target): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.type !== 0) {
      obj.type = planSimulation_TargetTypeToJSON(message.type);
    }
    return obj;
  },

  create(base?: DeepPartial<PlanSimulation_Target>): PlanSimulation_Target {
    return PlanSimulation_Target.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PlanSimulation_Target>): PlanSimulation_Target {
    const message = createBasePlanSimulation_Target();
    message.id = object.id ?? "";
    message.type = object.type ?? 0;
    return message;
  },
};

function createBasePlanSimulationData(): PlanSimulationData {
  return { items: [] };
}

export const PlanSimulationData: MessageFns<PlanSimulationData> = {
  encode(message: PlanSimulationData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      PlanSimulationData_Item.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanSimulationData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanSimulationData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.items.push(PlanSimulationData_Item.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanSimulationData {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => PlanSimulationData_Item.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PlanSimulationData): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => PlanSimulationData_Item.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<PlanSimulationData>): PlanSimulationData {
    return PlanSimulationData.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PlanSimulationData>): PlanSimulationData {
    const message = createBasePlanSimulationData();
    message.items = object.items?.map((e) => PlanSimulationData_Item.fromPartial(e)) || [];
    return message;
  },
};

function createBasePlanSimulationData_Item(): PlanSimulationData_Item {
  return { percentile: 0, estimateHours: 0 };
}

export const PlanSimulationData_Item: MessageFns<PlanSimulationData_Item> = {
  encode(message: PlanSimulationData_Item, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.percentile !== 0) {
      writer.uint32(13).float(message.percentile);
    }
    if (message.estimateHours !== 0) {
      writer.uint32(21).float(message.estimateHours);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlanSimulationData_Item {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanSimulationData_Item();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.percentile = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.estimateHours = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanSimulationData_Item {
    return {
      percentile: isSet(object.percentile) ? globalThis.Number(object.percentile) : 0,
      estimateHours: isSet(object.estimateHours)
        ? globalThis.Number(object.estimateHours)
        : isSet(object.estimate_hours)
        ? globalThis.Number(object.estimate_hours)
        : 0,
    };
  },

  toJSON(message: PlanSimulationData_Item): unknown {
    const obj: any = {};
    if (message.percentile !== 0) {
      obj.percentile = message.percentile;
    }
    if (message.estimateHours !== 0) {
      obj.estimateHours = message.estimateHours;
    }
    return obj;
  },

  create(base?: DeepPartial<PlanSimulationData_Item>): PlanSimulationData_Item {
    return PlanSimulationData_Item.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PlanSimulationData_Item>): PlanSimulationData_Item {
    const message = createBasePlanSimulationData_Item();
    message.percentile = object.percentile ?? 0;
    message.estimateHours = object.estimateHours ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
